import Popup from '@popup/components/Popup';
import Button from '@ui/components/Button';
import PopupWrapper from '@ui/components/PopupWrapper';

interface ModalProps {
  onClose: () => void;
}

const LeavePromptModal = ({ onClose }: ModalProps) => {
  return (
    <div className="fixed inset-x-2 bottom-2 z-10 flex items-center justify-center">
      <Popup>
        <PopupWrapper handleClick={onClose}>
          <div className="flex w-full flex-col space-y-8 py-2">
            <div className="mx-auto flex w-full flex-col items-center justify-center space-y-4 text-center md:mx-[118px] md:w-[322px]">
              <h3 className="text-2xl font-bold leading-[34px] text-brand-gray-100">
                Opravdu chcete odejít?
              </h3>
              <p className="text-base text-brand-gray-100">
                Provedené změny nebudou uloženy.<br></br>Událost budete muset
                vytvořit znovu.
              </p>
            </div>
            <div className="flex w-full flex-row justify-center space-x-6">
              <Button
                className="border border-brand-gray-300 sm:w-[195px]"
                type="pill"
                onClick={onClose}
              >
                Zrušit
              </Button>
              <Button
                className="bg-button-big bg-size-600% text-brand-white-100 hover:bg-center active:bg-right sm:w-[195px]"
                size="regular"
                link="/"
              >
                Odejít
              </Button>
            </div>
          </div>
        </PopupWrapper>
      </Popup>
    </div>
  );
};

export default LeavePromptModal;
